'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/@yxl/libs/~/axios/lib/cancel/isCancel.js
// module id = 6SyV
// module chunks = 0